'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _selects = require('../common/selects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LegalBriefForm = function (_React$Component) {
	_inherits(LegalBriefForm, _React$Component);

	function LegalBriefForm(props) {
		_classCallCheck(this, LegalBriefForm);

		var _this = _possibleConstructorReturn(this, (LegalBriefForm.__proto__ || Object.getPrototypeOf(LegalBriefForm)).call(this, props));

		_this.renderDisciplineSelect = _this.renderDisciplineSelect.bind(_this);
		_this.onNameChange = _this.onNameChange.bind(_this);
		_this.cancel = _this.cancel.bind(_this);
		_this.onClickSubmit = _this.onClickSubmit.bind(_this);
		_this.onDisciplineChange = _this.onDisciplineChange.bind(_this);
		return _this;
	}

	_createClass(LegalBriefForm, [{
		key: 'componentWillMount',
		value: function componentWillMount() {

			var initialState = {
				nameErrorMsg: '',
				disciplineErrorMsg: ''
			};

			if (typeof this.props.legalBrief !== 'undefined') {
				initialState.legalBrief = this.props.legalBrief;
			} else {
				initialState.legalBrief = {
					name: '',
					disciplineId: null
				};
			}

			this.setState(initialState);
		}
	}, {
		key: 'onClickSubmit',
		value: function onClickSubmit() {
			this.props.submit(this.state.legalBrief);
		}
	}, {
		key: 'onNameChange',
		value: function onNameChange(event, value) {
			this.setState({
				legalBrief: _extends({}, this.state.legalBrief, {
					name: value
				})
			});
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			this.props.cancel();
		}
	}, {
		key: 'onDisciplineChange',
		value: function onDisciplineChange(event, key, value) {
			var legalBrief = this.state.legalBrief;


			this.setState({ legalBrief: _extends({}, legalBrief, { disciplineId: value }) });
		}
	}, {
		key: 'renderDisciplineSelect',
		value: function renderDisciplineSelect() {
			var legalBrief = this.state.legalBrief;


			if (typeof legalBrief.id === 'undefined') {
				if (Object.keys(this.props.disciplines).length === 0) {
					this.props.fetchDisciplinesRequest();
				}

				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('br', null),
					_react2.default.createElement(_selects.SelectDiscipline, {
						selectedDiscipline: legalBrief.disciplineId,
						disciplineErrorMsg: this.state.disciplineErrorMsg,
						disciplines: this.props.disciplines,
						onSelectDiscipline: this.onDisciplineChange
					})
				);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var requestingCreateLegalBrief = this.props.requestingCreateLegalBrief;
			var _state = this.state,
			    legalBrief = _state.legalBrief,
			    nameErrorMsg = _state.nameErrorMsg;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_TextField2.default, {
						hintText: 'Nome',
						floatingLabelText: 'Nome',
						floatingLabelFixed: true,
						onChange: this.onNameChange,
						value: legalBrief.name,
						errorText: nameErrorMsg,
						fullWidth: true
					})
				),
				this.renderDisciplineSelect(),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_RaisedButton2.default, { label: 'Cancelar', onClick: this.cancel }),
					_react2.default.createElement(_RaisedButton2.default, {
						primary: true, label: 'Enviar',
						onClick: this.onClickSubmit,
						style: { marginLeft: '1rem' }
					}),
					requestingCreateLegalBrief && _react2.default.createElement(_CircularProgress2.default, null)
				)
			);
		}
	}]);

	return LegalBriefForm;
}(_react2.default.Component);

exports.default = LegalBriefForm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/legalBriefs/LegalBriefForm.js
// module id = 982
// module chunks = 0